import { MechanicTypeEnum, CalculationFunctionValuesEnum } from '../../model';

export const fromCalculationFunctionValueToMechanicType = (
  calculationFunction: CalculationFunctionValuesEnum,
): MechanicTypeEnum => {
  const mapper = {
    [CalculationFunctionValuesEnum.CF0]: MechanicTypeEnum.FIXED,
    [CalculationFunctionValuesEnum.CF1]: MechanicTypeEnum.PERCENT,
    [CalculationFunctionValuesEnum.CF2]: MechanicTypeEnum.FIXED,
    [CalculationFunctionValuesEnum.CF3]: MechanicTypeEnum.CONDITION,
    [CalculationFunctionValuesEnum.CF4]: MechanicTypeEnum.FIXED,
    [CalculationFunctionValuesEnum.CF5]: MechanicTypeEnum.CONDITION,
    [CalculationFunctionValuesEnum.CF6]: MechanicTypeEnum.ORDER,
  };

  return mapper[calculationFunction];
};
